<body class="ltr main-body leftmenu">

    <!-- Main Content-->
    <div class="main-content side-content pt-0 ml-0">
        <div class="main-container container-fluid">
            <div class="inner-body">
                <!-- Page Header -->
                <div class="page-header">
                    <div>
                        <h2 class="main-content-title tx-18 mg-b-5">{{'header.integrated-course-Data.titleList.AllIntegratedCourseRecords' | translate }}</h2>
                        <ol class="breadcrumb">
                            <li class="breadcrumb-item"><a href="#">{{'header.integrated-course-Data.titleList.IntegratedCourseData' | translate }}</a></li>
                            <li class="breadcrumb-item active" aria-current="page">{{'header.integrated-course-Data.titleList.AddIntegratedCourse' | translate }}</li>
                        </ol>
                    </div>
                    <div class="d-flex">
                        <div class="justify-content-center">
                            <!-- <button type="button" class="btn btn-white btn-icon-text my-2 me-2">
                                                        <i class="fe fe-download me-2"></i> Import
                                                    </button> -->
                            <button type="button" class="btn btn-primary my-2 btn-icon-text floatright" (click)="addnewrecord('true')">
                                {{'header.integrated-course-Data.titleList.AddNewRecord' | translate }}
                            </button>
                            <button type="button" class="btn btn-primary my-2 me-2  btn-icon-text floatright" (click)="download()">
                                <i class="fe fe-download-cloud me-2"></i> {{'header.integrated-course-Data.titleList.DownloadReport' | translate
                                }}
                            </button>
                        
                            <button mat-button [matMenuTriggerFor]="menu" type="button"
                                class="btn btn-white btn-icon-text my-2 me-2 dropdown-toggle floatright" data-toggle="dropdown">
                                <i class="fe fe-filter me-2"></i> Doc Type
                            </button>
                            <mat-menu #menu="matMenu">
                                <button mat-menu-item>.csv</button>
                                <button mat-menu-item>pdf</button>
                            </mat-menu>
                        </div>
                    </div>
                </div>
                <!-- End Page Header -->

                <!-- Row -->
                <!-- list of faculty start  -->
                <div class="row row-sm" *ngIf="list">
                    <div class="col-lg-12">
                        <div class="card custom-card">
                            <div class="card-body">
                                <div class="row">
                                    <div class="col-md-7">
                                        <h3 class="main-content-label mb-1"><b>{{'header.integrated-course-Data.titleList.IntegratedCourseList' | translate }}</b></h3>
                                        <p class="text-muted card-sub-title mb-0">{{'header.integrated-course-Data.titleList.IntegratedCourseDataInformation' | translate }}</p>
                                    </div>
                                    <div class="col-md-5" >
                                        <mat-form-field appearance="outline"
                                                class="row align-items-center floatright"
                                                
                                                 >
                                                <mat-label >Course Code </mat-label>
                                                   <mat-select #select1 formControlName="fcCode">
                                                    <mat-select-filter *ngIf="select1.focused" [placeholder]="'Filter'" [displayMember]="'CoCode'"
                                                    [array]="coCodeList"  (filteredReturn)="filteredListCoCode =$event"></mat-select-filter>
                                                    <mat-option  *ngFor="let row of filteredListCoCode" [value]="row.CoCode" (click)="integretedCourseSort(row)">{{row.CoCode}}</mat-option>
                                                  </mat-select>
                                               </mat-form-field>
                                        
                                    </div>
                                </div>
                                <div>
                                   
                                </div>
                                <div class="row form-data">
                                    <div class="col-lg-12">
                                        <div class="row align-items-center">
                                            <div class="col-sm-3 my-2 my-md-0">
                                                <!-- <div class="form-group" [formGroup]="inteCourseSearchForm" >
                                                    <div class="input-icon">
                                                        <input type="text" class="form-control search" formControlName="IcCoCode" (keyup)="keypress()"
                                                            placeholder="Search .." id="datatable_search_query">
                                                    </div>
                                                </div> -->
                                                <!-- <mat-form-field appearance="outline" class="example-full-width"    >
                                                    <mat-label>Search</mat-label>
                                                    <input matInput type="text"  placeholder="Search ..">
                                                  </mat-form-field> -->
                                            </div>
                                            <div class="col-sm-2 my-2 my-md-0">
                                                
                                            </div>
                                            <div class="col-sm-2 my-2 my-md-0">
                                                <!-- <div class="d-flex align-items-center">
                                                    <label class="mr-3 mb-0 mt-2 d-none d-md-block">Type:</label>
                                                    <div class="form-group">
                                                        <select name="country" class="form-control select-lg select2">
                                                            <option value="">Select</option>
                                                        </select>
                                                    </div>
                                                </div> -->
                                            </div>
                                            <div class="col-sm-5 text-right">
                                                <!-- <a href="#" class="btn btn-light-primary mr-3">Search</a> -->
                                                
                                                <!-- <button type="button" class="btn btn-white btn-icon-text my-2 me-2 btn-light-primary floatright">
                                                 Search
                                                </button> -->
                                            </div>

                                        </div>
                                    </div>
                                </div>
                                <div class="table-responsive">
                                    <table id="datatable" class="table table-striped table-bordered text-nowrap text-left">
                                        <thead>
                                            <tr>

                                                <th class="f600">
                                                    {{'header.integrated-course-Data.table.Inst' | translate }}
                                                </th>
                                                <th class="f600">
                                                    {{'header.integrated-course-Data.table.IcCoCode' | translate }}
                                                </th>
                                                <th class="f600">
                                                    {{'header.integrated-course-Data.table.IcSrNo' | translate }}
                                                </th>
                                                <th class="f600">
                                                    {{'header.integrated-course-Data.table.IcEmId' | translate }}
                                                </th>
                                                <th class="f600">
                                                    {{'header.integrated-course-Data.table.IcCertName' | translate }}
                                                </th>
                                                <th class="f600">
                                                    {{'header.integrated-course-Data.table.IcCertTo' | translate }}
                                                </th>
                                                <!-- <th>Status</th>
                                                <th>Type</th> -->
                                                <!-- <th width="10%" class="f600 text-center">{{'header.integrated-course-Data.table.Action' | translate }}</th> -->
                                            </tr>
                                        </thead>
                                        <tbody id="table_data">
                                            <tr *ngFor="let faculty of inteCourseList;">

                                                <td> {{faculty.Inst ? faculty.Inst:"NA"}} </td>
                                                <td>{{faculty.IcCoCode ? faculty.IcCoCode:"NA"}} </td>
                                                <td> {{faculty.IcSrNo ? faculty.IcSrNo:"NA"}} </td>
                                                <td>{{faculty.IcEmId ? faculty.IcEmId:"NA"}} </td>
                                                <td> {{faculty.IcCertName ? faculty.IcCertName:"NA"}} </td>
                                                <td>{{faculty.IcCertTo ? faculty.IcCertTo:"NA"}} </td>
                                                <!-- <td><span class="label-light-primary">Cancelled </span></td>
                                                <td class="text-success">• Direct</td> -->
                                                <!-- <td class="text-center">
                                                     
                                                    <a class="btn-floating" title="Edit"
                                                        (click)="editdata('true',faculty.IcCoCode)">
                                                        <i class="fa fa-edit"></i>
                                                    </a>
                                                    <a class="btn-floating" title="Delete"
                                                        (click)="delete(faculty.IcCoCode)">
                                                        <i class="fas fa-trash"></i>
                                                    </a>
                                                </td> -->
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <!-- list of faculty end  -->
                <!-- add of faculty start  -->
                <div class="row row-sm add-form" *ngIf="list == false ">
                    <form autocomplete="off" class="p-0" novalidate [formGroup]="inteCourseForm">
                   <div class="col-lg-12 col-md-12">

                            <div class="card custom-card">
                                <div class="card-body">
                                    <div *ngIf="submitButton">
                                        <h3 class="main-content-label mb-1"><b>{{'header.integrated-course-Data.titleList.AddNewIntegratedCourseRecord' | translate }}</b></h3>
                                        <p class="text-muted card-sub-title mb-0">{{'header.integrated-course-Data.titleList.AddNewIntegratedCourseInformation' | translate }} </p>
                                    </div>
                                    <div *ngIf="editButton">
                                        <h3 class="main-content-label mb-1"><b>{{'header.integrated-course-Data.titleList.UpdateIntegratedCourseRecord' | translate }}</b></h3>
                                        <p class="text-muted card-sub-title mb-0">{{'header.integrated-course-Data.titleList.UpdateSelectedIntegratedCourseInformation' | translate }}
                                        </p>
                                    </div>
                                    <div class="row clearfix">
                                        <div class="col-sm-4">
                                            <div class="form-group">
                                                <div class="">
                                                    <mat-form-field appearance="outline" class="example-full-width" >
                                                        <mat-label>{{'header.integrated-course-Data.titleList.Inst' | translate }}</mat-label>
                                                        <input matInput formControlName="Inst"
                                                            placeholder="Inst" required>
                                                    </mat-form-field>
                                                    <mat-error class="margin_tp"
                                                        *ngIf="inteCourseForm.controls['Inst'].touched && inteCourseForm.controls['Inst'].errors?.required">
                                                        This fild is mandatory.
                                                    </mat-error>
                                                    <mat-error class="margin_tp"
                                                        *ngIf="inteCourseForm.controls['Inst'].touched && inteCourseForm.controls['Inst'].errors?.pattern">
                                                        Please Enter Valid Data
                                                    </mat-error>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="col-sm-4">
                                            <div class="form-group">
                                                <div class="">
                                                    <mat-form-field appearance="outline" class="example-full-width" >
                                                        <mat-label>{{'header.integrated-course-Data.titleList.IcCoCode' | translate }}</mat-label>
                                                        <!-- <input matInput formControlName="IcCoCode"
                                                            placeholder="IcCoCode" required> -->
                                                            <mat-select #select3 placeholder="IcCoCode" class="colorblack"  formControlName="IcCoCode"   >
                                                                <mat-select-filter *ngIf="select3.focused" [placeholder]="'Filter'" [displayMember]="'EmCoCode'"
                                                                  [array]="examStreamCourseList"  (filteredReturn)="filteredListExamStreamCode =$event"></mat-select-filter>                             
                                                                <mat-option *ngFor="let item of filteredListExamStreamCode"                            
                                                                 [value]="item.EmCoCode" >                            
                                                                  {{item.EmCoCode}}                            
                                                                </mat-option>                            
                                                              </mat-select>
                                                        </mat-form-field>
                                                    <mat-error class="margin_tp"
                                                        *ngIf="inteCourseForm.controls['IcCoCode'].touched && inteCourseForm.controls['IcCoCode'].errors?.required">
                                                        This field is mandatory
                                                    </mat-error>
                                                    <mat-error class="margin_tp"
                                                    *ngIf="inteCourseForm.controls['IcCoCode'].touched && inteCourseForm.controls['IcCoCode'].errors?.pattern">
                                                    Please Enter Valid Data
                                                </mat-error>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="col-sm-4">
                                            <div class="form-group">
                                                <div class="">
                                                    <mat-form-field appearance="outline" class="example-full-width" >
                                                        <mat-label>{{'header.integrated-course-Data.titleList.IcSrNo' | translate }}</mat-label>
                                                        <!-- <input matInput formControlName="IcSrNo"
                                                            placeholder="IcSrNo" required> -->
                                                            <mat-select #select33 placeholder="IcSrNo" class="colorblack"  formControlName="IcSrNo"   >
                                                                <mat-select-filter *ngIf="select33.focused" [placeholder]="'Filter'" [displayMember]="'EmSrNo'"
                                                                  [array]="examStreamCourseList"  (filteredReturn)="filteredListExamStreamCode =$event"></mat-select-filter>                             
                                                                <mat-option *ngFor="let item of filteredListExamStreamCode"                            
                                                                 [value]="item.EmSrNo" >                            
                                                                  {{item.EmSrNo}}                            
                                                                </mat-option>                            
                                                              </mat-select>
                                                    </mat-form-field>
                                                    <mat-error class="margin_tp"
                                                        *ngIf="inteCourseForm.controls['IcSrNo'].touched && inteCourseForm.controls['IcSrNo'].errors?.required">
                                                       This Field is mandatory
                                                    </mat-error>
                                                    <mat-error class="margin_tp"
                                                    *ngIf="inteCourseForm.controls['IcSrNo'].touched && inteCourseForm.controls['IcSrNo'].errors?.pattern">
                                                    Please Enter Valid Data
                                                </mat-error>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="col-sm-4">
                                            <div class="form-group">
                                                <div class="">
                                                    <mat-form-field appearance="outline" class="example-full-width" >
                                                        <mat-label>{{'header.integrated-course-Data.titleList.IcEmId' | translate }}</mat-label>
                                                        <input style="color:black;" matInput formControlName="IcEmId"
                                                            placeholder="IcEmId" required>
                                                    </mat-form-field>
                                                    <mat-error class="margin_tp"
                                                        *ngIf="inteCourseForm.controls['IcEmId'].touched && inteCourseForm.controls['IcEmId'].errors?.required">
                                                        This field is mandatory
                                                    </mat-error>
                                                    <mat-error class="margin_tp"
                                                    *ngIf="inteCourseForm.controls['IcEmId'].touched && inteCourseForm.controls['IcEmId'].errors?.pattern">
                                                    Please Enter Valid Data
                                                </mat-error>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="col-sm-4">
                                            <div class="form-group">
                                                <div class="">
                                                    <mat-form-field appearance="outline" class="example-full-width" >
                                                        <mat-label>{{'header.integrated-course-Data.titleList.IcCertName' | translate }}</mat-label>
                                                        <input style="color:black;" matInput formControlName="IcCertName"
                                                            placeholder="IcCertName" required>
                                                    </mat-form-field>
                                                    <mat-error class="margin_tp"
                                                        *ngIf="inteCourseForm.controls['IcCertName'].touched && inteCourseForm.controls['IcCertName'].errors?.required">
                                                        This field is mandatory
                                                    </mat-error>
                                                    <mat-error class="margin_tp"
                                                    *ngIf="inteCourseForm.controls['IcCertName'].touched && inteCourseForm.controls['IcCertName'].errors?.pattern">
                                                    Please Enter Valid Data
                                                </mat-error>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="col-sm-4">
                                            <div class="form-group">
                                                <div class="">
                                                    <mat-form-field appearance="outline" class="example-full-width" >
                                                        <mat-label>{{'header.integrated-course-Data.titleList.IcCertTo' | translate }}</mat-label>
                                                        <input style="color:black;" matInput formControlName="IcCertTo"
                                                            placeholder="IcCertTo" required>
                                                    </mat-form-field>
                                                    <mat-error class="margin_tp"
                                                        *ngIf="inteCourseForm.controls['IcCertTo'].touched && inteCourseForm.controls['IcCertTo'].errors?.required">
                                                        This is is mandatory.
                                                    </mat-error>
                                                    <mat-error class="margin_tp"
                                                    *ngIf="inteCourseForm.controls['IcCertTo'].touched && inteCourseForm.controls['IcCertTo'].errors?.pattern">
                                                    Please Enter Valid Data
                                                </mat-error>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="col-sm-12">
                                            <button type="submit" class="btn btn-primary my-2 me-2 btn-icon-text floatright btn-raised g-bg-blush2"
                                                *ngIf="submitButton" (click)="submit()">{{'header.integrated-course-Data.titleList.Submit' | translate }}</button>
                                            <button type="submit" class="btn btn-primary my-2 me-2 btn-icon-text floatright btn-raised g-bg-blush2" *ngIf="editButton"
                                                (click)="update()">{{'header.integrated-course-Data.titleList.Update' | translate }}</button>
                                            <button type="submit" class="btn btn-primary my-2 me-2 btn-icon-text floatright btn-raised g-bg-blush2"
                                                (click)="addnewrecord('false')">{{'header.integrated-course-Data.titleList.Back' | translate }}</button>

                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </form>
                </div>
                <!-- list of faculty end  -->
            </div>
        </div>
    </div>
</body>

<!-- [dataSource]="dataSource" -->